import Landing from './landing.js';
import Main from './main.js';
import Steps from './steps.js';
import Contact from './contact.js';
import Interview from './interview.js';
import Resume from './resume.js';

export default {
  Landing,
  Main,
  Steps,
  Contact,
  Interview,
  Resume,
};
